import { render, staticRenderFns } from "./popup-container.vue?vue&type=template&id=c18dfd74&"
import script from "./popup-container.vue?vue&type=script&lang=ts&"
export * from "./popup-container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c18dfd74')) {
      api.createRecord('c18dfd74', component.options)
    } else {
      api.reload('c18dfd74', component.options)
    }
    module.hot.accept("./popup-container.vue?vue&type=template&id=c18dfd74&", function () {
      api.rerender('c18dfd74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/popup/popup-container.vue"
export default component.exports